// assets/wearwho-countdown.js
// Drives all [data-deadline] countdown elements on the page.
// Deadline format: ISO 8601 date string, e.g. "2025-09-30"

(function () {
  'use strict';

  function updateCountdown(el) {
    var deadline = new Date(el.dataset.deadline + 'T23:59:59');
    var now = new Date();
    var diff = deadline - now;

    if (diff <= 0) {
      el.innerHTML = '<span style="color:#EF4444;font-weight:700;">Orders Closed</span>';
      return;
    }

    var days    = Math.floor(diff / (1000 * 60 * 60 * 24));
    var hours   = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((diff % (1000 * 60)) / 1000);

    function pad(n) { return String(n).padStart(2, '0'); }

    var dEl = el.querySelector('.ww-countdown__days');
    var hEl = el.querySelector('.ww-countdown__hours');
    var mEl = el.querySelector('.ww-countdown__minutes');
    var sEl = el.querySelector('.ww-countdown__seconds');

    if (dEl) dEl.textContent = pad(days);
    if (hEl) hEl.textContent = pad(hours);
    if (mEl) mEl.textContent = pad(minutes);
    if (sEl) sEl.textContent = pad(seconds);
  }

  var countdowns = document.querySelectorAll('.ww-countdown[data-deadline]');
  if (!countdowns.length) return;

  countdowns.forEach(updateCountdown);
  setInterval(function () { countdowns.forEach(updateCountdown); }, 1000);
})();
